import { AccessorsMutatorsDecorator } from '../../helpers';
import { TranslatableModel } from './translatable-model';

/**
 * @class ReservationInvoice
 */
export class ReservationInvoice extends TranslatableModel {

    formatUrl(value = this.url) {

        const split = (value || '').split('/');

        return split[split.length - 1];
    }
}

AccessorsMutatorsDecorator(
    'id',
    'index',
    'ident',
    'url',
    'url_ar',
    'name',
    'reservation_id',
    'created_at',
    'created_at_tz',
    'invoice_date',
    'from_date',
    'to_date',
    'comment',
    'amount',
    'nights',
    'created_by',
    'reservation_invoice_credit_note',
    'credit_note_index',
)(ReservationInvoice);



// WEBPACK FOOTER //
// ./src/pms-api/models/reservation-invoice.model.js